import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  timelineOppositeContentClasses,
  TimelineSeparator,
} from '@mui/lab';
import { Card, CardContent, Link, Typography } from '@mui/material';
import { IconCurrencyRupee } from '@tabler/icons';

const RecentTransactions = ({ transactions }) => {
  return (
    <Card>
      <Typography variant="h5" sx={{ margin: 2 }}>
        Recent Transactions
      </Typography>
      {!transactions ? (
        <Typography sx={{ textAlign: 'center', color: 'gray', mb: 2 }}>
          No Recent Transactions Found
        </Typography>
      ) : (
        <CardContent>
          <Timeline
            className="theme-timeline"
            nonce={undefined}
            onResize={undefined}
            onResizeCapture={undefined}
            sx={{
              p: 0,
              '& .MuiTimelineItem-root': {
                minHeight: '54px',
              },
              '& .MuiTimelineConnector-root': {
                width: '1px',
                backgroundColor: '#efefef',
              },
              [`& .${timelineOppositeContentClasses.root}`]: {
                flex: 0.5,
                paddingLeft: 0,
              },
            }}
          >
            {transactions.reverse().map((entry) => {
              return (
                <>
                  <TimelineItem>
                    <TimelineOppositeContent>
                      <Link href="#" underline="none">{`${new Date(entry.timestamp).getDate()} ${
                        new Date(entry.timestamp).toDateString().split(' ')[1]
                      } ${new Date(entry.timestamp).toDateString().split(' ')[3]}`}</Link>
                      <Typography fontWeight="600">{entry.source}</Typography>{' '}
                    </TimelineOppositeContent>
                    <TimelineSeparator>
                      <TimelineDot color="secondary" variant="outlined" />
                      <TimelineConnector />
                    </TimelineSeparator>
                    <TimelineContent>
                      <Typography fontWeight="600" sx={{ display: 'flex', alignItems: 'center' }}>
                        <IconCurrencyRupee width={20} />
                        {entry.amount}
                      </Typography>{' '}
                      <Link href="#" underline="none">
                        {entry?.note}
                      </Link>
                    </TimelineContent>
                  </TimelineItem>
                </>
              );
            })}
          </Timeline>
        </CardContent>
      )}
    </Card>
  );
};

export default RecentTransactions;
